module.exports = __webpack_public_path__ + "img/solution_building7.732eb641.png";